import { RecordManagementService } from './api/record-management.service';
import { UtilService } from './services/util.service';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from './api/user.service';
import { BehaviorSubject, Observable } from 'rxjs';
import { Constants } from './helpers/messages';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';

@Injectable({
  providedIn: 'root'
})
export class AppService {
  private loginStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private profilePic: BehaviorSubject<any> = new BehaviorSubject<any>('');

  profileImage: string | ArrayBuffer;

  constructor(
    public userService: UserService,
    public snackBar:MatSnackBar,
    public helperService: UtilService,
    public recordService: RecordManagementService,
    private router: Router,
    private dialog: MatDialog
  ) { 
    this.checkLoginStatus()
    this.idleLogout()
  }
  
  setLoginStatus(){
    this.loginStatus.next(true)
    // this.getProfilePic()
  }

  idleLogout() {
    var t;
    var route = this.router
    var context = this
    window.onload = resetTimer;
    window.onmousemove = resetTimer;
    window.onmousedown = resetTimer;  // catches touchscreen presses as well      
    window.ontouchstart = resetTimer; // catches touchscreen swipes as well 
    window.onclick = resetTimer;      // catches touchpad clicks as well
    window.onkeypress = resetTimer;   
    window.addEventListener('scroll', resetTimer, true); // improved; see comments

    function logout(){
      context.dialog.closeAll();
      context.loginStatus.next(false)
      context.snackBar.open('SESSION EXPIRIED, LOGIN TO CONTINUE',"OK",{
        duration:8000
      })
      route.navigate(['/']);
      localStorage.clear();
    }

    function resetTimer() {
      clearTimeout(t);
      t = setTimeout(logout, 1000 * 60 * 30 );  // time is in milliseconds
    }
  }

  logoutUser(){
    localStorage.clear()
    this.loginStatus.next(false)
    this.router.navigateByUrl('/');
  }

  getProfilePic() {
    let userid = this.helperService.getUserId()

    this.userService.retrievePhoto(userid)
      .subscribe(res => {
        if (res['message']) {
          return
        }
        this.createImageFromBlob(res)
      }, err => {
    })
  }

  createImageFromBlob(image) {
    let reader = new FileReader();
    reader.addEventListener("load", () => {
      this.profileImage = reader.result;
      this.setProfilePics(this.profileImage)
    }, false);
    if (image) {
      reader.readAsDataURL(image);
    }
  }
  

  loginObserverable(){
    return this.loginStatus.asObservable()
  }

  setProfilePics(val:any): void {
    this.profilePic.next(val);
  }
  
  getPicture(): Observable<string>{
    return this.profilePic.asObservable();
  }
  
  checkLoginStatus() {
    let login:any =  this.helperService.getFromStore(Constants.LOGIN_USER)
    
    if (login !== null) {
      this.loginStatus.next(true);
      this.getProfilePic()
    }

    else {
      this.loginStatus.next(false);
    }
  }

}

